<template>
  <div>
    <v-row
      class="page-break"
      no-gutters>
      <v-col cols="12">
        <p class="field-label">
          <b>Brand:</b>
          <span>
            {{ brand || '' }}
          </span>
        </p>
      </v-col>
      <v-col cols="2">
        <p class="field-label">
          <b> ID: </b>
          <span>{{ sketchId }} </span>
        </p>
      </v-col>
      <v-col cols="2">
        <p class="field-label">
          <b> Date: </b>
          <span>{{ createdAt }} </span>
        </p>
      </v-col>
      <v-col cols="4">
        <p class="field-label">
          <b> Product Type: </b>
          <span>{{ avoidEmptyString(category) }} </span>
        </p>
      </v-col>
      <v-col cols="4">
        <p class="field-label">
          <b> Collection: </b>
          <span>{{ avoidEmptyString(collectionName) }} </span>
        </p>
      </v-col>
      <v-col cols="2">
        <p class="field-label">
          <b> Designer: </b>
          <span>{{ avoidEmptyString(designer) }} </span>
        </p>
      </v-col>
      <v-col cols="2">
        <p class="field-label">
          <b> Merchandiser: </b>
          <span>{{ avoidEmptyString(merchandiser) }} </span>
        </p>
      </v-col>
      <v-col cols="4">
        <p class="field-label">
          <b> Factory: </b>
          <span>{{ avoidEmptyString(factory) }} </span>
        </p>
      </v-col>
      <v-col
        cols="12"
        class="pb-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="sketch-image-row">
      <v-col cols="12">
        <p class="field-label mb-0">
          <b>
            Sketch Image:
          </b>
        </p>
      </v-col>
      <v-col
        v-for="(skImage, skImgIndex) in sketchImages"
        :key="`sketch-images(${skImgIndex})`"
        :class="{ 'sketch-image-singel': isSingleSketchImage }"
        class="sketch-image img-preview-col"
        cols="12">
        <div class="img-preview-wrap">
          <img
            class="image-preview export-preview-img"
            :src="$convertImgix(`${skImage}?w=1024`)">
        </div>
      </v-col>
      <v-col
        cols="12"
        class="sketch-note">
        <p>
          <b>Note:</b>
        </p>
        <p>
          {{ avoidEmptyString(sketchNote, 'ไม่ระบุ') }}
        </p>
      </v-col>
    </v-row>
    <div class="page-break-after"></div>
    <v-row class="material-row">
      <v-col cols="12">
        <p class="field-label mb-0">
          <b>
            Fabric Detail
          </b>
        </p>
      </v-col>
    </v-row>
    <div
      v-for="(fabric, fabricIndex) in fabrics"
      :key="`material-row-fabric(${fabricIndex})`">
      <v-row
        :class="{'page-break ': fabricIndex !== 0}"
        class="material-image-row">
        <v-col cols="3">
          <p>
            <b>Sketch ID:</b>
          </p>
          <p>
            {{ fabric.sketchId || '' }}
          </p>
        </v-col>
        <v-col cols="3">
          <p>
            <b>Hang ID:</b>
          </p>
          <p>
            {{ fabric.hangId || '' }}
          </p>
        </v-col>
        <v-col cols="3">
          <p>
            <b>Fabric No:</b>
          </p>
          <p>
            {{ fabric.fabricNo || '' }}
          </p>
        </v-col>
        <v-col cols="3">
          <p>
            <b>Quantity:</b>
          </p>
          <p>
            {{ avoidEmptyString(fabric.amount) }}
          </p>
        </v-col>
        <v-col cols="12">
          <p>
            <b>Garment Part:</b>
          </p>
          <p>
            {{ fabric.garmentPart && fabric.garmentPart.en ? fabric.garmentPart.en : '-' }}
          </p>
        </v-col>
        <v-col
          v-for="(fabricImage, fabricImageIndex) in fabric.imageUrls"
          :key="`material-images(${fabricImageIndex})`"
          class="material-image img-preview-col"
          :class="{
            'last-material-image': isLastImage(fabricIndex, fabricImageIndex, fabrics)
          }"
          cols="6">
          <div class="img-preview-wrap">
            <img
              class="image-preview export-preview-img"
              :src="$convertImgix(`${fabricImage}?w=1024`)">
          </div>
        </v-col>
        <v-col
          v-for="(pattern, pIndex) in fabric.patterns"
          :key="pIndex"
          cols="12">
          <v-row>
            <v-col cols="12">
              <h4>
                Pattern Note: {{ avoidEmptyString(pattern.note) }}
              </h4>
            </v-col>
            <v-col
              v-for="(patternImage, patternImageIndex) in pattern.imageUrls"
              :key="`pattern-image-${patternImageIndex}`"
              class="material-image img-preview-col"
              :class="{
                'last-image': isLastImage(pIndex, patternImageIndex, pattern.imageUrls)
              }"
              cols="6">
              <div class="img-preview-wrap">
                <img
                  class="image-preview export-preview-img"
                  :src="$convertImgix(`${patternImage}?w=1024`)">
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <p>
            <b>Note:</b>
          </p>
          <p>
            {{ avoidEmptyString(fabric.note, 'ไม่ระบุ') }}
          </p>
        </v-col>
      </v-row>
      <div
        :key="`page-break-after-${fabricIndex}`"
        class="page-break-after" />
    </div>
    <v-row class="material-row">
      <v-col cols="12">
        <p class="field-label mb-0">
          <b>
            Material Detail
          </b>
        </p>
        <p
          v-if="!materials.length"
          class="field-label mt-2">
          ไม่ระบุ
        </p>
      </v-col>
    </v-row>
    <div
      v-for="(material, materialIndex) in materials"
      :key="`material-row-material(${materialIndex})`">
      <v-row
        :class="{'page-break ': materialIndex !== 0}"
        class="material-image-row">
        <v-col cols="3">
          <p>
            <b>Name:</b>
          </p>
          <p>
            {{ material.name || '' }}
          </p>
        </v-col>
        <v-col cols="3">
          <p>
            <b>Color:</b> {{ material.color || '' }}
          </p>
          <p>
            <b>Material:</b> {{ material.material || '' }}
          </p>
          <p>
            <b>Size:</b> {{ material.size || '' }}
          </p>
        </v-col>
        <v-col cols="3">
          <p>
            <b>Quantity:</b>
          </p>
          <p>
            {{ material.amount || '' }}
          </p>
        </v-col>
        <v-col
          v-for="(materialImage, materialImageIndex) in material.imageUrls"
          :key="`material-images(${materialImageIndex})`"
          class="material-image img-preview-col"
          :class="{
            'last-material-image': isLastImage(materialIndex, materialImageIndex, materials)
          }"
          cols="6">
          <div class="img-preview-wrap">
            <img
              class="image-preview export-preview-img"
              :src="$convertImgix(`${materialImage}?w=1024`)">
          </div>
        </v-col>
        <v-col
          v-for="(pattern, pIndex) in material.patterns"
          :key="`material-pattern-${pIndex}`"
          cols="12">
          <v-row>
            <v-col cols="12">
              <h4>
                Pattern Note: {{ pattern.note }}
              </h4>
            </v-col>
            <v-col
              v-for="(patternImage, patternImageIndex) in pattern.imageUrls"
              :key="`pattern-image-${patternImageIndex}`"
              class="material-image img-preview-col"
              :class="{
                'last-image': isLastImage(pIndex, patternImageIndex, pattern.imageUrls)
              }"
              cols="6">
              <div class="img-preview-wrap">
                <img
                  class="image-preview export-preview-img"
                  :src="$convertImgix(`${patternImage}?w=1024`)">
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <p>
            <b>Note:</b>
          </p>
          <p>
            {{ material.note || '' }}
          </p>
        </v-col>
      </v-row>
      <div
        :key="`page-break-after-${materialIndex}`"
        class="page-break-after" />
    </div>
    <v-row
      v-if="requirePrintFabricLabel"
      class="material-row mb-2">
      <v-col
        v-if="fabrics.length"
        cols="12">
        <p class="text-bold">
          Fabric Label :
        </p>
        <div class="d-flex justify-start align-left">
          <v-card
            elevation="0"
            class="text-center"
          >
            <fabric-example
              :fabric-compositions="fabrics"
              :sketch-id="sketchId" />
          </v-card>
        </div>
      </v-col>
      <v-col
        v-else
        cols="12">
        <p>ไม่ระบุ</p>
      </v-col>
    </v-row>
    <v-row
      class="material-row">
      <v-col
        cols="12">
        <p class="text-bold">
          Garment Type :
        </p>
        <div v-if="garmentType">
          <p> {{ garmentType.toUpperCase() }}</p>
        </div>
        <p v-else>
          ไม่ระบุ
        </p>
      </v-col>
    </v-row>
    <v-row
      v-if="requirePrintCareLabel"
      class="material-row">
      <v-col
        cols="12">
        <p class="text-bold">
          Care Label :
        </p>
        <div v-if="careLabel">
          <p> <b>Code </b> {{ careLabel.name }}</p>
          <img
            v-if="careLabel.imageUrl"
            class="mt-4"
            :src="$convertImgix(`${careLabel.imageUrl}?w=1024`)"
            width="250"
            alt="">
        </div>
        <p v-else>
          ไม่ระบุ
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p><b>Size Details</b></p>
        <v-row>
          <v-col cols="auto">
            <v-simple-table
              v-if="hasSizeDetail"
              dense>
              <thead>
                <tr>
                  <th>
                    <p class="label mb-0 text-center">
                      Detail / Size
                    </p>
                  </th>
                  <th
                    v-for="(size) in sizeDetail"
                    :key="`head-sizeDetail-${size.size}`">
                    <p class="label mb-0 text-uppercase text-center">
                      {{ size.size }}
                    </p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(key, keyIndex) in optionKeys"
                  :key="`mainkey-${keyIndex}`">
                  <td class="text-center">
                    {{ key }}
                  </td>
                  <td
                    v-for="(size, sizeIndex) in sizeDetail"
                    :key="`sizeDetail-${sizeIndex}-${keyIndex}`"
                    class="text-center">
                    {{ size.options[keyIndex].value }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <p
              v-else
              class="text-center">
              ไม่มี Size Details
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="page-break-after"></div>
  </div>
</template>

<script>
import { prototypeData } from '@/assets/js/DefaultPrototypeData'
import { mapGetters } from 'vuex'
import FabricExample from './FabricExample.vue'

export default {
  components: {
    FabricExample
  },
  props: {
    prototype: {
      type: Object,
      default: () => prototypeData
    }
  },
  computed: {
    ...mapGetters({
      storeSetting: 'Store/storeSetting'
    }),
    brand () {
      return this.prototype?.sketch?.brand || ''
    },
    sketchId () {
      return this.prototype?.sketch?.sketchId || ''
    },
    createdAt () {
      return this.prototype?.sketch?.createdAt ? this.$dayjs(this.prototype.sketch.createdAt).format('DD/MM/YYYY') : ''
    },
    category () {
      return this.prototype?.sketch?.category?.name || ''
    },
    collectionName () {
      return this.prototype?.sketch?.collectionName || ''
    },
    factory () {
      return this.prototype?.sketch?.factory?.name || ''
    },
    merchandiser () {
      return this.prototype?.sketch?.merchandiser?.name || ''
    },
    designer () {
      return this.prototype?.sketch?.designer?.name || ''
    },
    sketchImages () {
      return this.prototype?.sketch?.images || []
    },
    isSingleSketchImage () {
      return this.sketchImages.length === 1
    },
    sketchNote () {
      return this.prototype?.sketch?.note || ''
    },
    materials () {
      return this.prototype?.sketch?.materials || []
    },
    fabrics () {
      return this.prototype?.sketch?.fabrics || []
    },
    sizeDetail () {
      return this.prototype?.sketch?.sizeDetail || []
    },
    optionKeys () {
      const { sizeDetail } = this
      if (!Array.isArray(sizeDetail) || sizeDetail.length === 0 || !Array.isArray(sizeDetail[0].options) || sizeDetail[0].options.length === 0) {
        return []
      }
      return sizeDetail[0].options.map((option) => option.key)
    },
    hasSizeDetail () {
      return this.optionKeys.length > 0
    },
    requirePrintCareLabel () {
      return this.prototype?.requirePrintCareLabel ?? true
    },
    requirePrintFabricLabel () {
      return this.prototype?.requirePrintFabricLabel ?? true
    },
    careLabel () {
      return this.prototype?.sketch?.careLabel || null
    },
    garmentType () {
      return this.prototype?.sketch?.garmentType || null
    }
  },
  methods: {
    modItems (items) {
      const arrItems = []
      for (let i = 0; i < items.length; i++) {
        const qtyItem = items[i]?.imageUrls?.length || 0
        arrItems.push((qtyItem - (qtyItem % 4)) - 1)
      }
      return arrItems
    },
    isLastImage (mIndex, imgIndex, items) {
      const modded = this.modItems(items)

      return imgIndex > modded[mIndex]
    },
    avoidEmptyString (text, defaultValue = '-') {
      return text || defaultValue
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 8.0pt;
  font-size: 11pt;
  line-height: 107%;
}
.img-preview-col {
  .img-preview-wrap {
    width: 100%;
    height: 100%;
    max-height: 800px;
    position: relative;
    img {
      margin: 0 auto;
      max-height: 100%;
      padding: 12px;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.sketch-image-row {
  .img-preview-col {
    height: 100vh;
  }
  .img-preview-col:first-child {
    height: 80vh;
  }
  .img-preview-col:last-child {
    height: 90vh;
  }
  .img-preview-col.sketch-image-singel {
    height: 60vh;
  }
}
.material-image-row {
  .material-image {
    height: 40vh;
    max-height: 290px;
  }
  .material-image.testtesttest {
    height: 35vh;
  }
}

</style>
